<template>
    <div>
      <div :id="id" class="platform-canvas"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  props: {
    id: {
      type: String,
      default: 'main'
    }
  },
  data() {
    return {
      chart: undefined,
      stackInfo: {},
      series: [
        {
          data: [19, 22, 70, 47, 38, 68, 31, 79, 81, 96, 89, 71],
          type: 'bar',
          stack: 'a',
          name: '京东快递快运',
          barWidth: 10,
        },
        {
          data: [7, 8, 11, 9, 20, 17, 10, 15, 16, 41, 13, 18],
          type: 'bar',
          stack: 'a',
          name: '京东云打印',
          barWidth: 10,
        },
        {
          data: [4, 5, 11, 7, 9, 7, 1, 7, 4, 3, 1, 1],
          type: 'bar',
          stack: 'a',
          name: '京东快递旧(新签客户勿用)',
          barWidth: 10,
        },
        {
          data: [0, 0, 5, 6, 8, 8, 7, 4, 6, 10, 4, 3],
          type: 'bar',
          stack: 'a',
          name: '京东快运旧(新签客户勿用)',
          barWidth: 10,
        },
        {
          data: [5, 5, 5, 5, 3, 5, 2, 6, 2, 4, 4, 5],
          type: 'bar',
          stack: 'a',
          name: '云仓【ERP】',
          barWidth: 10,
        },
        {

          data: [4, 1, 3, 2, 1, 8, 6, 2, 5, 7, 3, 6],
          type: 'bar',
          stack: 'a',
          name: '仓配一体旧（新签客户勿用）',
          barWidth: 10,
        },
        {
          data: [1, 1, 0, 0, 9, 0, 7, 11, 6, 1, 2, 3],
          type: 'bar',
          stack: 'a',
          name: '无界电子面单【承运商】',
          barWidth: 10,
        },
        {
          data: [2, 2, 4, 2, 2, 3, 0, 0, 1, 2, 0, 2],
          type: 'bar',
          stack: 'a',
          name: '云仓【WMS】',
          barWidth: 10,
        },
        {
          data: [0, 0, 0, 0, 0, 0, 0, 1, 2, 8, 2, 2],
          type: 'bar',
          stack: 'a',
          name: '一体化物流服务',
          barWidth: 10,
        },
        {
          data: [9, 3, 9, 5, 10, 5, 5, 12, 16, 15, 10, 1],
          type: 'bar',
          stack: 'a',
          name: '其他',
          barWidth: 10,
        }
      ],
      option: {
        xAxis: {
          type: 'category',
          data: ['2023-01', '2023-02', '2023-03', '2023-04', '2023-05', '2023-06', '2023-07', '2023-08', '2023-09', '2023-10', '2023-11', '2023-12'],
          axisTick: {
            show: true,
            alignWithLabel: true,
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        color: [
          '#3C6EF0',
          '#3AD3D9',
          '#435889',
          '#3EC986',
          '#FFD83D',
          '#A066E8',
          '#FC6D6D',
          '#FFA447',
          '#FB4C8D',
          '#AFB6C9',
        ],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          backgroundColor: 'rgba(35,37,43,0.9)',
          borderRadius: 8,
          height: 164,
          position (point, params, dom, rect, size) {

          },
          // enterable: true, // 允许鼠标进入提示框内部
          formatter(params) {
            let tooltipContent = '<div style="line-height: 26px; padding: 8px; height: 164px; width: max-content; color: #FFFFFF;">'
            tooltipContent += `<div>${params[0].name}</div>`
            tooltipContent += '<div style="display: grid; grid-template-columns: repeat(2,1fr);">'
            for (let i = 0; i < params.length; i++) {
              //
              tooltipContent += `<div>
                  <div style="
                  width: 10px; height: 10px;
                  border-radius: 10px;
                  background-color:${params[i].color}; 
                  display: inline-block; 
                  margin-right: 4px;"
                  >
                  </div>`
              tooltipContent += `<span>${params[i].seriesName}: ${params[i].value}</span></div>`
            }
            tooltipContent += '</div></div>'
            return tooltipContent
          }
        },
        legend: {
          bottom: 0,
          itemWidth: 10, // 设置图例项的宽度
          itemHeight: 10, // 设置图例项的高度
          itemStyle: {
            borderRadius: 10,
          },
          itemGap: 16, // 横向布局时为水平间隔，纵向布局时为纵向间隔
          data: [
            '京东快递快运',
            '京东云打印',
            '京东快递旧(新签客户勿用)',
            '京东快运旧(新签客户勿用)',
            '云仓【ERP】',
            '仓配一体旧（新签客户勿用）',
            '无界电子面单【承运商】',
            '云仓【WMS】',
            '一体化物流服务',
            '其他'
          ],
          icon: 'circle'
        },
        grid: {
          top: '5%',
          // bottom: '10%',
          left: '3.5%',
          right: '0%',
        },
      }
    }
  },
  mounted() {
    this.getData()
    this.option.series = this.series
    const chartDom = document.getElementById(`${this.id}`)
    // 调整canvas清晰度
    this.chart = echarts.init(chartDom, null, { devicePixelRatio: 2.5 })
    // this.chart = echarts.init(chartDom, null, { renderer: 'svg' })
    this.chart.setOption(this.option)
  },
  methods: {
    getData() {
      const { series, stackInfo } = this
      for (let i = 0; i < series[0].data.length; ++i) {
        for (let j = 0; j < series.length; ++j) {
          const stackName = series[j].stack
          if (!stackName) {
            // continue
          }
          if (!stackInfo[stackName]) {
            stackInfo[stackName] = {
              stackStart: [],
              stackEnd: []
            }
          }
          const info = stackInfo[stackName]
          const data = series[j].data[i]
          if (data && data !== '-') {
            if (info.stackStart[i] == null) {
              info.stackStart[i] = j
            }
            info.stackEnd[i] = j
          }
          stackInfo[stackName] = info
        }
      }
      for (let i = 0; i < series.length; ++i) {
        const info = stackInfo[series[i].stack]
        for (let j = 0; j < series[i].data.length; ++j) {
          const isEnd = info.stackEnd[j] === i
          const topBorder = isEnd ? 20 : 0
          const bottomBorder = 0
          series[i].data[j] = {
            value: series[i].data[j],
            itemStyle: {
              borderRadius: [topBorder, topBorder, bottomBorder, bottomBorder]
            }
          }
        }
      }
      this.series = series
      this.stackInfo = stackInfo
    },
  }
}
</script>

<style lang="scss">
  .platform-canvas {
    width: 1188px;
    height: 261px;
  }
</style>
